/**
 * Utility functions for handling flu shots status display
 */

export interface FluShotsStatus {
  displayText: string;
  bgColor: string;
}

/**
 * Maps flu shots custom field value to display text and background color
 * Handles backward compatibility with true/false strings and various formats
 *
 * @param value - The flu shots value from custom fields
 * @returns Object containing displayText and bgColor
 */
export const getFluShotsStatus = (value: string | undefined | null): FluShotsStatus => {
  const val = value || '';
  const lowerVal = val.toLowerCase();

  // Determine display text and color - backward compatible with true/false strings
  if (lowerVal === 'yes' || lowerVal === 'true' || lowerVal === 'available') {
    return {
      displayText: 'Available',
      bgColor: 'background.teal100'
    };
  } else if (lowerVal === 'no' || lowerVal === 'false' || lowerVal === 'not available') {
    return {
      displayText: 'Not Available',
      bgColor: 'background.red100'
    };
  } else if (lowerVal === 'limited') {
    return {
      displayText: 'Limited',
      bgColor: 'background.yellow100'
    };
  } else if (val) {
    // If there's a value but doesn't match known patterns, show it as-is
    return {
      displayText: val,
      bgColor: 'background.gray100'
    };
  }

  // Default fallback
  return {
    displayText: 'Not Available',
    bgColor: 'background.red100'
  };
};
